module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Color name","pageDesc":"Test your color combinations and palettes. Calculate the contrast ratio to give your design depth and personality."},"ar":{"pageTitle":"اسم اللون","pageDesc":"اختبر تركيبات الألوان واحسب التباين لإعطاء عمق للتصميم والشخصية من خلال الظلال وامنح تصميمك الروح واجعلها نابضة بالحياة"}}')
  delete Component.options._Ctor
}
